<template>
  <div>
    <div class="vuse-content-wrapper mt-4">
      <div>
          <v-row >
            <v-col>              
              <h2 class="ml-3">
                Campagne Marketing
                <!--
                <span>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">     
                      <v-btn icon color="primary" v-on="on" @click="xmlReport">
                        <ExcelIcon />
                      </v-btn>
                    </template>
                    <span>Download Table as CSV</span>
                  </v-tooltip>
                </span>
                -->
                <span class="ml-2">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">     
                      <v-btn fab icon small color="info" v-on="on" @click="customers=[];getData()" :loading="loading" class="neu-glow">
                        <v-icon>mdi-sync</v-icon>
                      </v-btn>
                    </template>
                    <span>Refresh</span>
                  </v-tooltip>
                </span>
                <!--
                <span class="ml-8">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">     
                      <v-btn fab icon small color="info" v-on="on" to="users" class="neu-glow">
                        <v-icon>mdi-account-group</v-icon>
                      </v-btn>
                    </template>
                    <span>Utenti</span>
                  </v-tooltip>
                </span>
                -->                 
              </h2>
            </v-col>

            <!--
            <v-spacer></v-spacer>
            <v-col cols="6" class="text-right pr-8">
              <v-btn @click="dialog_range=true">Periodo: {{rangeString}}</v-btn>
            </v-col>
            -->              
          </v-row>
          <template v-if="!campaigns && !loading">
            <no-data />  
          </template>
          <template v-else>  
            <v-row class="pl-1 px-5">
              <v-col cols="12" class="ma-2">
                <v-card class="neu-glow pb-4">
                  <v-card-title>
                    <v-row>
                      <div class="ml-5 pt-3" v-if="campaigns"></div>
                      <v-spacer></v-spacer>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details
                          class="mt-n4"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-data-table
                      :loading="!campaigns"
                      fixed-header="true"
                      :headers="headers"
                      :items="campaigns||[]"
                      :items-per-page="5000"
                      :height="wIH - 289"
                      :search="search"
                      loading-text="Loading... Please wait"
                      :hide-default-footer="true"
                      class="mx-5 neu-glow"
                  >              
                    <!--
                    <template v-slot:[`item.approved`]="{ item }">
                      <v-switch color="info" 
                      @click="save(item,'approved','campaigns')" 
                      v-model="item.approved"
                      :label="item.approved?'SI':'NO'"
                      >
                      </v-switch>
                    </template>  
                    

                    <template v-slot:[`item.brand`]="{ item }">
                      <v-div>{{item.brand}}</v-div>
                    </template>
                    -->

                    <template v-slot:[`item.approved`]="{ item }">
                      <v-switch 
                        color="info" 
                        v-model="item.approved"
                        :label="item.approved?'SI':'NO'"
                        @click="save(item,'approved','campaigns')" 
                      >
                      </v-switch>
                    </template>                     
 
                    <template v-slot:[`item.TS`]="{ item }">
                      <v-span>{{formatDT(item.TS,'dmy')}}</v-span>
                    </template>

                    <template v-slot:[`item.startDate`]="{ item }">
                      <v-span>{{formatDT(item.startDate,'dmy')}}</v-span>
                    </template>

                    <template v-slot:[`item.endDate`]="{ item }">
                      <v-span>{{formatDT(item.endDate,'dmy')}}</v-span>
                    </template>                                        

                    <template v-slot:[`item.provisionalAmount`]="{ item }">
                      <v-span>{{item.provisionalAmount.toFixed(2)}}</v-span>
                    </template>

                    <template v-slot:[`item.active`]="{ item }">
                      <v-switch color="info" 
                      v-model="item.active"
                      :label="item.active?'SI':'NO'"
                      readonly
                      >
                      </v-switch>
                    </template> 
                    


                    
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </div>
    </div>

    <v-dialog
      v-model="dialog_confirm"
      persistent
      width="600px"
    >
      <v-card class="neu-glow pb-1">
        <v-card-title>
          Confermi Operazione?
          <v-spacer></v-spacer>            
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="save(selectedCustomer.accountId,'all','dueDate')">
                <v-icon color="info">mdi-check-bold</v-icon>
              </v-btn>
            </template>
            <span>Esegui</span>
          </v-tooltip> 
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_confirm=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>                     
        </v-card-title>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_range"
      persistent
      width="600px"
    >
      <v-card class="neu-glow pb-1">
        <v-card-title>
          Scegli Periodo
          <v-spacer></v-spacer>            
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_range=false;customers=[];getData()">
                <v-icon color="info">mdi-check</v-icon>
              </v-btn>
            </template>
            <span>OK</span>
          </v-tooltip>           
        </v-card-title>
        <v-card class="neu-glow ma-4">
          <v-date-picker
            v-model="dateRange"
            scrollable
            range
            color="info"
            show-adjacent-months
            full-width
            :first-day-of-week="1"
            locale="it"
            show-week
          >
          </v-date-picker>
        </v-card>
      </v-card>
    </v-dialog>          
    <v-snackbar v-model="snackbar" top right :width="120" :color="snackbar_color" style='z-index:20001;'>
      <span>{{snackbar_message}}</span>
    </v-snackbar>
  </div>
</template>
<style scoped>
.v-input__slot{
  min-height:30px!important;
  max-height:20px!important;
}
</style>
<script>
import { mapGetters } from "vuex";
import NoData from "@/components/NoData";
import _ from 'lodash'

export default {
  components: { NoData},
  computed : {
    ...mapGetters(["settings"]),
    today:function()
    {
      var yourDate=new Date();
      const of = yourDate.getTimezoneOffset()
      yourDate = new Date(yourDate.getTime() - (of*60*1000))
      return yourDate.toISOString().split('T')[0]
    },    
  },
  data() {
    return {
      page: "Boss",
      UserID:null,
      username:'',
      formValid:true,
      pl_dialog:false,
      dialog_modules:false,
      dialog_invoicing:false,
      dialog_range:false,
      dialog_confirm:false,
      dialog_invoice_text:false,
      active_pricelist:null,
      campaigns:null,
      custom_pricelist:[],
      menu:[],
      msg_modal:false,
      msg:{},
      htmlBody:'',
      wIH:window.innerHeight,
      loading: true,
      errorid: null,
      search: '',
      customers: [],
      info_dialog:false,
      snackbar:false,
      snackbar_message:'',
      snackbar_color:'',
      sendbutton_color:'info',
      sendbutton_text:'Send',
      sendingmail:false,
      //pickedDate:null,
      selectedCustomer:null,
      dateRange:[(new Date(new Date().getFullYear(),new Date().getMonth(), 2)).toISOString().substring(0, 10),(new Date(new Date().getFullYear(),new Date().getMonth()+1, 1)).toISOString().substring(0, 10)],
      rangeString:null,
      invoiceRemarks:'',
      invoiceRemarks2:'',
      forceExpiry:null,
      dateForAllModules:null,
      headers: [
        { text: 'Autorizza',    value: 'approved',class:'text-button font-weight-bold' },
        { text: 'Cliente',      value: 'brand',align:'start',class:'text-button font-weight-bold' },
        { text: 'Data',         value: 'TS',align:'start',class:'text-button font-weight-bold' },
        { text: 'Attiva',       value: 'active',class:'text-button font-weight-bold' },
        { text: 'Campagna',     value: 'name',align:'start',class:'text-button font-weight-bold' },
        { text: 'Inizio',       value: 'startDate', align: 'start',class:'text-button font-weight-bold'},
        { text: 'Fine',         value: 'endDate', align: 'start',class:'text-button font-weight-bold'},
        { text: 'Invii',        value: 'sendings', align: 'end',class:'text-button font-weight-bold'},
        { text: 'Destinatari',  value: 'recipients', align: 'end',class:'text-button font-weight-bold'},
        { text: 'Messaggi',     value: 'messages', align: 'end',class:'text-button font-weight-bold'},
        { text: 'Importo €',    value: 'provisionalAmount',align: 'end', class:'text-button font-weight-bold info--text' }
      ],
    };
  },
  created(){
    this.$vuetify.theme.dark = true
    this.getData()
  },
  watch : {

  },
  methods:
  {
        formatDT(v,p)
        {
            var o=null;
            v=new Date(v)
            switch (p)
            {
                case 'dmy':
                    o={year:'numeric',month:'2-digit',day:'2-digit'}
                break;
                case 'dm':
                    o={month:'2-digit',day:'2-digit'}
                break;
                case 'dmyhms':
                    o={year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit'}
                break;
                case 'ddmy':
                    o={weekday: "long",year:'numeric',month:'2-digit',day:'2-digit'}
                break;                
                case 'hms':
                    o={hour:'2-digit',minute:'2-digit',second:'2-digit'}
                break;   
                case 'hm':
                    o={hour:'2-digit',minute:'2-digit'}
                break;
                case 'z':
                    o={year:'numeric',month:'2-digit',day:'2-digit'}
                break;
                case 'W':
                    o={weekday:'long'}
                break; 
                case 'w':
                    o={weekday:'short'}
                break;                                                                           
            }
            //console.log(2527,v,p)
            var vv=new Intl.DateTimeFormat('it',o).format(v);
            //console.log(2529,v,p,vv)
            return vv
        },    
    copyToClipboard(txt)
    {
      navigator.clipboard.writeText(txt);
      this.snackbar_color="success"
      this.snackbar_message ='Copiato negli Appunti';
      this.snackbar = true;
    },    
    range_string()
    {
      console.log(260,this.dateRange)
      var date = new Date(this.dateRange[0]), y = date.getFullYear(), m = date.getMonth();
      var date2 =new Date(this.dateRange[1])
      var firstDay = new Date(y, m, 1);
      var lastDay = new Date(y, m + 1, 0);
      this.monthName=firstDay.toLocaleString('it',{month:"long"})
      console.log(683,firstDay,lastDay,firstDay.toLocaleDateString('it', options) + ' - ' + lastDay.toLocaleDateString('it', options))
      const options={ year: 'numeric', month: '2-digit', day: '2-digit' };
      //return new Date(this.dateRange[0]).toLocaleDateString('it', options) + ' - ' + new Date(this.dateRange[1]).toLocaleDateString('it', options)
      //var k=firstDay.toLocaleDateString('it', options) + ' - ' + lastDay.toLocaleDateString('it', options)
      var k=date.toLocaleDateString('it', options) + ' - ' + date2.toLocaleDateString('it', options)
      this.rangeString=k;
      console.log(867,k,this.monthName)
      //return k
    },    
    save: _.debounce(function (item,field,type='') {
      let jwt=sessionStorage.getItem('jwt');
      console.log(372,item,field,type,this.selectedCustomer);
      let vl='';
      let payload='';
      switch (type)
      {
        case 'campaigns'://dateForAll
          vl=item.approved;
          payload={"jwt":jwt,"payload":{"action":"approve_campaign","table": "MKTCampaigns", "field": field, "value": vl, "campaignId":item.campaignId}};
        break;
      }
      console.log(374,vl,payload,this.formValid)
      this.update_db(payload)
    }, 1000),     
    async update_db(payload){
      try
      {
          const res = await this.$http.post('/boss/actions.php', payload);
          //const res = await this.$http.post('/boss/actions.php', {"jwt":jwt,"payload":{"action":"pricelist","field":field,"userid":item.uuid,"value":value}});
          switch (res.data.errorid)
          {
            case '0':
              this.snackbar_color='success';
              this.snackbar_message=res.data.message;
              console.log(257,res.data.message);
              this.snackbar=true;
               console.log(259,this.snackbar);
            break;

            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
            default:
              this.snackbar_color='red darken-2';
              this.snackbar_message=res.data.message;
          }
      }
      catch(e)
      {
          console.log(264,e);
          this.snackbar_color='red darken-2';
          this.snackbar_message='Connection Error - Try Later';
      }
      console.log(276)
      this.snackbar=true;
    },

    dialog_modules_open(item)
    {
      this.dialog_modules=true;
      this.selectedCustomer=item;
    },
    async xmlReport(){
      let jwt=sessionStorage.getItem('jwt');
      let payload={"jwt":jwt};
      window.location.href='/ajax/boss/customers_xls.php?json='+encodeURIComponent(JSON.stringify(payload));
    },
    async getData(){
      let jwt=sessionStorage.getItem('jwt');
      this.range_string();
      this.loading=true;
      try
      {
          const payload=JSON.stringify({"dateRange": this.dateRange,"date": this.date,"action":"getCampaigns"});
          const res = await this.$http.post('/boss/users.php', payload );
          this.loading= false;
          this.errorid=res.data.errorid;
          switch (res.data.errorid)
          {
            case '0':
              this.campaigns=res.data.payloads;
              //console.log(this.customers);
            break;

            case '0001':
              this.campaigns = res.data.payloads;
            break;

            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }

      }
      catch(e)
      {
          this.loading= false;
      }
    },
  }
};
</script>
<style>
.v-data-table-header th {
  white-space: nowrap;
}
</style>